module.exports = __webpack_public_path__ + "static/media/  (157).df4dc357.jpg";